<script>
export default {
  name: 'VNode',
  props: {
    vnodes: Object,
  },
  render() {
    return this.vnodes ? this.vnodes : '';
  },
};
</script>